// src/pages/IssueReporting/components/TicketSummary.js
import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { AlertTriangle, Clock, CheckCircle, XCircle } from 'react-feather';

// Summary card component
const SummaryCard = ({ title, count, icon, color, bgColor }) => (
    <Paper
        elevation={0}
        sx={{
            p: 2,
            borderRadius: '10px',
            border: '1px solid rgba(0, 0, 0, 0.08)',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }}
    >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                {title}
            </Typography>
            <Box
                sx={{
                    p: 1,
                    borderRadius: '50%',
                    backgroundColor: bgColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                {icon}
            </Box>
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 700, color }}>
            {count}
        </Typography>
    </Paper>
);

const TicketsSummary = ({ ticketCounts }) => {
    // Ensure ticketCounts is properly defined with defaults
    const counts = {
        total: 0,
        open: 0,
        inProgress: 0,
        resolved: 0,
        closed: 0,
        ...ticketCounts
    };

    return (
        <Box sx={{ mb: 4 }}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <SummaryCard
                        title="Total Tickets"
                        count={counts.total}
                        icon={<AlertTriangle size={20} color="#6366F1" />}
                        color="#6366F1"
                        bgColor="rgba(99, 102, 241, 0.1)"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <SummaryCard
                        title="Open Tickets"
                        count={counts.open}
                        icon={<AlertTriangle size={20} color="#EF4444" />}
                        color="#EF4444"
                        bgColor="rgba(239, 68, 68, 0.1)"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <SummaryCard
                        title="In Progress"
                        count={counts.inProgress}
                        icon={<Clock size={20} color="#F59E0B" />}
                        color="#F59E0B"
                        bgColor="rgba(245, 158, 11, 0.1)"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <SummaryCard
                        title="Resolved"
                        count={counts.resolved + counts.closed}
                        icon={<CheckCircle size={20} color="#10B981" />}
                        color="#10B981"
                        bgColor="rgba(16, 185, 129, 0.1)"
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default TicketsSummary;